const ColumnSize = [
  { smallSize: true },
  { percent: '30', smallSize: true, textCenter: true },
  { percent: '30', smallSize: true, textCenter: true },
  { percent: '15', smallSize: true, textCenter: true },
];

export default ColumnSize;
